import { number, string } from "zod";

export const validateIndex = (search: Record<string, unknown>) => {
  return {
    index: number().default(0).parse(search.index),
  };
};

export const validateOrderId = (search: Record<string, unknown>) => {
  return {
    orderId: string().parse(search.orderId),
  };
};
